export default {
  PUSH_REPORT: 'PUSH_REPORT',
  PUSH_REPORTS: 'PUSH_REPORTS',
  PUSH_OPEN_REPORTS: 'PUSH_OPEN_REPORTS',
  PUSH_REPORTS_FOR_APPROVE: 'PUSH_REPORTS_FOR_APPROVE',
  RESET_REPORTS_STATE: 'RESET_REPORTS_STATE',
  SET_IS_ADDING_REPORT: 'SET_IS_ADDING_REPORT',
  SET_IS_EDITING_REPORT: 'SET_IS_EDITING_REPORT',
  SET_IS_VIEWING_REPORT: 'SET_IS_VIEWING_REPORT',
  REPLACE_REPORT: 'REPLACE_REPORT',
  UPDATE_SIGN_ACTORS: 'UPDATE_SIGN_ACTORS',
  SET_REPORTS_IS_LOADING: 'SET_REPORTS_IS_LOADING',
  REMOVE_REPORT: 'REMOVE_REPORT',
};
